'use client';

import { apiFetch } from './api';

export interface ClientGalleryPayload {
  gallery: {
    id: string;
    name: string;
    description: string | null;
    type: string;
  };
  photos: Array<{
    id: string;
    title: string | null;
    description: string | null;
    url: string;
  }>;
}

export const clientService = {
  // Returns null when the access code doesn't match a client gallery
  async fetchClientGalleryByCode(accessCode: string): Promise<ClientGalleryPayload | null> {
    try {
      return await apiFetch<ClientGalleryPayload>('/api/client-access', {
        method: 'POST',
        json: { code: accessCode.trim() },
      });
    } catch (error: any) {
      if (error?.status === 404 || error?.status === 400) return null;
      console.error('Error fetching client gallery by code:', error);
      throw error;
    }
  },
};
